import styled, { css } from 'styled-components';

const StyledContainer = styled.div`
	position: relative;

	img {
		position: absolute;
		top: 50%;
		right: 20px;
		transform: translateY(-50%);
		transition: filter 0.3s ease;
	}
`;

const StyledInput = styled.input<{ $readonly?: boolean; $noinvert?: boolean }>`
	width: 100%;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	padding: 15px 50px 15px 15px;

	color: #ffffff;
	font-family: GT Walsheim Pro;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;

	transition: all 0.3s ease;

	&:focus {
		outline: none;
	}

	&::placeholder {
		color: rgba(255, 255, 255, 0.25);
		transition: color 0.3s ease;
	}

	${(props) =>
		!props.$readonly
			? css`
					&:hover,
					&:active,
					&:focus {
						background-color: rgba(255, 255, 255, 1);
						color: #000000;

						& + img {
							filter: ${!props.$noinvert && 'invert(100%)'};
						}

						&::placeholder {
							color: rgba(0, 0, 0, 0.25);
						}
					}
			  `
			: css`
					cursor: default;
			  `}
`;

export { StyledContainer, StyledInput };
